import React, { useEffect, useState, useContext } from 'react';
import style from './Add.module.css';


import { AppContext } from "../../AppContext";
import { db, storage } from "../../firebase";
import { doc, collection, setDoc, deleteDoc, addDoc } from 'firebase/firestore';
import urls from '../../urls';
import icons from '../../icons';
import { deleteObject, listAll, ref, uploadBytesResumable } from 'firebase/storage';
import Banner from '../Banner/Banner';
import OptionSelection from './OptionSelection/OptionSelection';
import Popup from '../Popup/Popup';
import TextButton from '../Buttons/TextButton/TextButton';
import ErrorSnackbar from '../ErrorSnackbar/ErrorSnackbar';

import useDidMount from '../../Hooks/useDidMount';
import useSpeechRecognition from '../../Hooks/useSpeechRecognition';
import IconButton from '../Buttons/IconButton/IconButton';


const getItalianMonth = month => {
    switch (month) {
        case 0:
            return "Gennaio";
        case 1:
            return "Febbraio";
        case 2:
            return "Marzo";
        case 3:
            return "Aprile";
        case 4:
            return "Maggio";
        case 5:
            return "Giugno";
        case 6:
            return "Luglio";
        case 7:
            return "Agosto";
        case 8:
            return "Settembre";
        case 9:
            return "Ottobre";
        case 10:
            return "Novembre";
        case 11:
            return "Dicembre";
    }
};

const addDays = (date, days) => {
    let newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};

const literalGrades = [
    "0", "0+", "0½", "1-",
    "1", "1+", "1½", "2-",
    "2", "2+", "2½", "3-",
    "3", "3+", "3½", "4-",
    "4", "4+", "4½", "5-",
    "5", "5+", "5½", "6-",
    "6", "6+", "6½", "7-",
    "7", "7+", "7½", "8-",
    "8", "8+", "8½", "9-",
    "9", "9+", "9½", "10-",
    "10", "10+"
];

const numericGrades = [
    0, 0.3, 0.5, 0.8,
    1, 1.3, 1.5, 1.8,
    2, 2.3, 2.5, 2.8,
    3, 3.3, 3.5, 3.8,
    4, 4.3, 4.5, 4.8,
    5, 5.3, 5.5, 5.8,
    6, 6.3, 6.5, 6.8,
    7, 7.3, 7.5, 7.8,
    8, 8.3, 8.5, 8.8,
    9, 9.3, 9.5, 9.8,
    10, 10

];

const getNumericGrade = literalGrade => {
    if (typeof literalGrade == 'undefined') return "";
    return numericGrades[literalGrades.indexOf(literalGrade)];
};

const getLiteralGrade = numericGrade => {
    if (typeof numericGrade == 'undefined') return "";
    return literalGrades[numericGrades.indexOf(parseInt(numericGrade))];
}

const Add = props => {
    const { showNavBar, page, user, users, subjects, timetable, setTests, setInterrogations, setHomeworks, setOthers, setPage } = useContext(AppContext);

    const [selectingOption, setSelectingOption] = useState(null);
    const [description, setDescription] = useState(props.description ?? "");
    const [type, setType] = useState(props.type ?? null);
    const [oldType, setOldType] = useState(props.type ?? null);
    const [subject, setSubject] = useState(props.subject ?? null);
    const [startDate, setStartDate] = useState(props.startDate ? new Date(props.startDate) : props.date ? new Date(props.date) : new Date());
    const [endDate, setEndDate] = useState(props.endDate ? new Date(props.endDate) : new Date());
    const [replaceLesson, setReplaceLesson] = useState(props.replaceLesson ?? false);
    const [duration, setDuration] = useState(props.duration ?? 1);
    const [showDurationChoice, setShowDurationChoice] = useState(false);
    const [showTimePicker, setShowTimePicker] = useState(false);
    const [replaceLessonPopup, setReplaceLessonPopup] = useState(false);
    const [eventUsers, setEventUsers] = useState(props.for ?? []);
    const [saving, setSaving] = useState(false);
    const [grade, setGrade] = useState({ show: false, grade: null, inGradeAverage: true });
    const [showAttachments, setShowAttachments] = useState(false);
    const [showUploadingAttachments, setShowUploadingAttachments] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [uploadingAttachments, setUploadingAttachments] = useState({});
    const [premiumNeededPopup, setPremiumNeededPopup] = useState(false);
    const [error, setError] = useState({ show: false, error: "" });
    const { startRecognition, stopRecognition, recording: speechRecognitonRunning } = useSpeechRecognition(setDescription);
    
    const didMount = useDidMount();

    const isSpeechRecognitionAvailable = () => window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    const getSubjectIcon = subjectName => {
        let returnIcon = "question_mark_orange_icon";

        if (subjects)
            Object.values(subjects).forEach(subject => {
                if (subject.subject?.toLowerCase() === subjectName?.toLowerCase()) returnIcon = subject.icon;
            });

        return returnIcon;
    };

    const getTypeIcon = eventType => {
        switch (eventType) {
            case "test":
                return icons.test_icon;
            case "interrogation":
                return icons.interrogation_icon;
            case "homework":
                return icons.home_orange_icon;
            default:
                return icons.question_mark_orange_icon;
        }
    };

    const getItalianType = eventType => {
        switch (eventType) {
            case "test":
                return "Verifica";
            case "interrogation":
                return "Orale";
            case "homework":
                return "Per casa";
            case "other":
                return "Altro";
            default:
                return "Scegli";
        }
    };

    const prettifyDate = date => {
        return String(date).length === 1 ? `0${date}` : String(date);
    };

    const save = async () => {
        if (saving)
            return;
            
        if (!description || !type || !subject || !startDate || (type === "interrogation" && !endDate)) {
            setError({ show: true, error: "Riempi tutti i campi!" });
            return;
        }

        setSaving(true);
        const docRef = doc(collection(db, `schools/${user.school}/classes/${user.class}/${type}s`));
        const setState = type === "test" ? setTests : type === "interrogation" ? setInterrogations : type === "homework" ? setHomeworks : setOthers;
        const newEvent = {
            id: props.id ?? docRef.id,
            title: description,
            type, 
            subject,
            for: eventUsers, 
            done: { [user.id]: false },
            addedBy: user.id,
            grades: { [user.id]: { inGradeAverage: grade.inGradeAverage ?? false } },
        };

        if (grade.grade)
            newEvent.grades[user.id].grade = getNumericGrade(grade.grade);

        if (type === "interrogation") {
            newEvent.startDate = startDate.toString();
            newEvent.endDate = endDate.toString();
        } else {
            newEvent.date = startDate.toString();
            newEvent.replaceLesson = replaceLesson;
            newEvent.replaceLesson = replaceLesson;
            newEvent.duration = duration;
        }

        if (oldType && oldType !== type) {
            await deleteDoc(doc(db, `schools/${user.school}/classes/${user.class}/${oldType}s`, props.id));
            const setOldState = oldType === "test" ? setTests : oldType === "interrogation" ? setInterrogations : oldType === "homework" ? setHomeworks : setOthers;
            setOldState(oldEvents => ({ ...Object.fromEntries(Object.entries(oldEvents).filter(([_, oldEvent]) => oldEvent.id !== props.id)) }));
        }

        const saveToDb = async () => {
            setState(oldEvents => ({ ...oldEvents, [newEvent.id]: newEvent }));
            await setDoc(doc(db, `schools/${user.school}/classes/${user.class}/${type}s`, newEvent.id), newEvent);
            setSaving(false);

            setPage({ page: "home" });
            fetch(urls.notifyEventAdded, {                
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    user: user,
                    newEvent,
                    subjects,
                    timetable,
                    users,
                    notify: !oldType
                })
            })

        }

        if (attachments.length !== 0) {
            const completedUploads = [];

            setUploadingAttachments(Object.fromEntries(attachments.filter(attachment => !attachment._location).map(attachment => ([attachment.name, { name: attachment.name, progress: 0 }]))));
            setShowUploadingAttachments(true);

            attachments.filter(attachment => attachment._location && attachment.deleted)
                .forEach(async attachment => await deleteObject(ref(storage, attachment._location.path)));

            newEvent.attachments = attachments.filter(attachment => !attachment.deleted).map(attachment => attachment.name ?? attachment._location.path.split("/")[-1]);
            
            if (attachments.filter(attachment => !attachment._location).length === 0)
                await saveToDb();

            attachments.filter(attachment => !attachment._location).forEach(attachment => {
                const attachmentRef = ref(storage, `${user.school}/${user.class}/${newEvent.type}s/${newEvent.id}/${attachment.name}`);
                const uploadTask = uploadBytesResumable(attachmentRef, attachment);

                uploadTask.on('state_changed', 
                    snapshot => {
                        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        const newAttachment = { name: attachment.name, progress };
                        setUploadingAttachments(oldUploadingAttachments => ({ ...oldUploadingAttachments, [attachment.name]: newAttachment }));
                    },
                    error => {
                        console.warn(`Error with file ${attachment}: ${error}`);

                        const newAttachment = { name: attachment.name, progress: 100, uploaded: true };
                        setUploadingAttachments(oldUploadingAttachments => ({ ...oldUploadingAttachments, [attachment.name]: newAttachment }));
                        completedUploads.push(attachment);
                    },
                    async () => {
                        const newAttachment = { name: attachment.name, progress: 100, uploaded: true };
                        setUploadingAttachments(oldUploadingAttachments => ({ ...oldUploadingAttachments, [attachment.name]: newAttachment }));
                        completedUploads.push(attachment);

                        if (completedUploads.length === attachments.filter(attachment => !attachment._location).length)
                            await saveToDb();
                    }
                );
            });

            return;
        };

        await saveToDb();
    };

    const deleteEvent = async () => {
        if (saving)
            return;

        setSaving(true);
        await deleteDoc(doc(db, `schools/${user.school}/classes/${user.class}/${oldType}s`, props.id));
        const setState = oldType === "test" ? setTests : oldType === "interrogation" ? setInterrogations : oldType === "homework" ? setHomeworks : setOthers;
        setState(oldEvents => ({ ...Object.fromEntries(Object.entries(oldEvents).filter(([_, oldEvent]) => oldEvent.id !== props.id)) }));
        setSaving(false);
        setPage({ page: "home" });
    }

    const getSubjectLessons = (date=startDate) => {
        const dayTimetable = timetable?.[date.getDay()];
        if (!dayTimetable)
            return [];

        if (replaceLesson)
            return Object.values(dayTimetable);

        const subjectLessons = Object.entries(dayTimetable).filter(([startTime, lesson]) => lesson.subjectTitle === subject).map(([startTime, lesson]) => [startTime, lesson.endTime]);
        [...subjectLessons].forEach((lesson, index) => subjectLessons[index][2] = Object.keys(dayTimetable).indexOf(lesson[0]));

        if (subjectLessons.length > 0) return subjectLessons;
        else return Object.values(dayTimetable);
    };

    const getSubjectLessonsAfterSelected = () => {
        const subjectLessons = getSubjectLessons();
        const dayTimetable = Object.values(timetable?.[startDate.getDay()] ?? []);

        if (!dayTimetable)
            return [];
            
        if (replaceLesson) 
            return dayTimetable.slice(dayTimetable.indexOf(dayTimetable.filter(lesson => lesson.startTime === `${prettifyDate(startDate.getUTCHours())}:${prettifyDate(startDate.getUTCMinutes())}`)?.[0]));

        let selectedIndex = subjectLessons.filter(lesson => lesson[0] === `${prettifyDate(startDate.getUTCHours())}:${prettifyDate(startDate.getUTCMinutes())}`)?.[0]?.[2];
        if (selectedIndex === null || selectedIndex === undefined)
            return dayTimetable.slice(dayTimetable.indexOf(dayTimetable.filter(lesson => lesson.startTime === `${prettifyDate(startDate.getUTCHours())}:${prettifyDate(startDate.getUTCMinutes())}`)?.[0]));;
            
        const lessons = [];
        let lesson = true, index = 0;

        while (lesson) {
            lesson = dayTimetable[selectedIndex + index]?.subjectTitle === subject;
            if (lesson) lessons.push(subjectLessons[index]);
            index += 1;
        };

        return lessons;
    };

    const setDateWithLesson = date => {
        if (!date || !getSubjectLessons(date)?.[0])
            return date;

        let newStartDate = new Date(date.toString());
        newStartDate.setUTCHours(parseInt((getSubjectLessons(date)[0][0] ?? getSubjectLessons(date)[0].startTime).split(":")[0]));
        newStartDate.setUTCMinutes(parseInt((getSubjectLessons(date)[0][0] ?? getSubjectLessons(date)[0].startTime).split(":")[1]));
                                
        if (newStartDate.getDate() === date.getDate() + 1)
            newStartDate = addDays(newStartDate, - 1);
        else if (newStartDate.getDate() === date.getDate() - 1)
            newStartDate = addDays(newStartDate, + 1);

        return newStartDate;
    };

    useEffect(() => {
        if (props.id != undefined && props.type != undefined)
            listAll(ref(storage, `${user.school}/${user.class}/${props.type}s/${props.id}`)).then(eventAttachments => setAttachments(eventAttachments.items));
    }, []);

    useEffect(() => {
        if (didMount && oldType !== type)
            setEndDate(null);
    }, [type]);

    useEffect(() => {
        if (!didMount || props.id) {
            if (!didMount && props.subject)
                setStartDate(setDateWithLesson(new Date(props.date ?? props.startDate)));
        } else {
            setEndDate(null);
            setDuration(1);
            setStartDate(setDateWithLesson(new Date()));
        }
    }, [subject]);

    useEffect(() => {
        if (getSubjectLessons().length === 0 && subject)
            setError({ show: true, error: `Non hai lezione di ${subject} quel giorno!` })
    }, [startDate]);

    useEffect(() => {
        showNavBar();
    }, [selectingOption, showTimePicker, showDurationChoice]);

    useEffect(() => {
        setGrade(oldGrade => ({ ...oldGrade, grade: getLiteralGrade(props.grades?.[user?.id]?.grade) || null }))
    }, [user]);

    useEffect(() => {
        if (attachments.every(attachment => attachment.uploaded))
            setShowUploadingAttachments(false);
    }, [attachments]);

    // if (!timetable && )

    return <>
        <OptionSelection 
            option={ selectingOption }
            selectedOptions={{
                type,
                subject,
                startDate,
                endDate,
                replaceLesson,
                duration
            }}
            value={ 
                selectingOption === "type" ? type :  
                selectingOption === "subject" ? subject :  
                selectingOption === "date" ? [startDate, endDate] :  
                selectingOption === "replaceLesson" ? replaceLesson :  
                selectingOption === "duration" ? duration :  
                selectingOption === "time" ? startDate :   
                selectingOption === "users" ? eventUsers : null  
            }
            back={ () => setSelectingOption(null) }
            select={ value => {
                switch (selectingOption) {
                    case "type":
                        setType(value);
                        break;
                    case "subject":
                        setSubject(value);
                        break;
                    case "date":
                        setStartDate(setDateWithLesson(value[0] ?? new Date()));
                        // setStartDate(value[0] ?? new Date());
                        setEndDate(value[1] ?? new Date());
                        break;
                    case "replaceLesson":
                        setReplaceLesson(value);
                        break;
                    case "time":
                        setReplaceLesson(value);
                        break;
                    case "duration":
                        setDuration(value);
                        break;
                    case "users":
                        setEventUsers(oldEventUsers => {
                            if (!value)
                                return [];

                            let newEventUsers = [...oldEventUsers];
                            if (newEventUsers.includes(value)) 
                                newEventUsers = newEventUsers.filter(item => item !== value);
                            else
                                newEventUsers.push(value);
                            return newEventUsers;
                        });
                        break;
                };

                if (selectingOption !== "users")
                    setSelectingOption(null);
            } } 
            setError={ setError }
        />
        <main className={ style.main } style={{ height: selectingOption && "0" }} onClick={ () => {
            setShowDurationChoice(false);
            setShowTimePicker(false);
            setGrade(oldGrade => ({ ...oldGrade, show: false }));
        } }>
            <div className={ style.flex }>
                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ () => setPage({ page: page.from || "home" }) }></img>
                { props.id ? <h2>Modifica<br></br><span style={{ color: "var(--orange)" }}>Evento</span></h2> : <h2>Aggiungi<br></br>Nuovo <span style={{ color: "var(--orange)" }}>Evento</span></h2> }
            </div>
            <Banner />
            <ErrorSnackbar error={ error.error } show={ error.show } setShow={ show => setError(oldError => ({ ...oldError, show })) } />
            <h5 className={ style.subHeader }>Descrizione evento</h5>
            <textarea className={ style.description } value={ description } onChange={ e => setDescription(e.target.value) }></textarea>
            { isSpeechRecognitionAvailable() && <img src={ user.premium ? (speechRecognitonRunning ? icons.stop_icon : icons.mic_icon) : icons.ic_mic_disabled } className={ style.voiceInputBtn } style={{ background: !user.premium && "rgba(0, 0, 0, .4)" }} onClick={ () => {
                if (!user.premium) {
                    setPremiumNeededPopup(true);
                    return;
                }

                if (!speechRecognitonRunning) startRecognition();
                else stopRecognition();
            } }></img> }
            <div className={ style.detailsContainer }>
                <div className={ style.detail } onClick={ () => setSelectingOption("subject") }>
                    <img src={ icons[getSubjectIcon(subject)] }></img>
                    <div>
                        <h4 className={ style.detailName }>Materia</h4>
                        <h4 className={ style.detailValue }>{ subject ?? "Scegli" }</h4>
                    </div>
                </div>
                <div className={ style.detail } onClick={ () => setSelectingOption("type") }>
                    <img src={ getTypeIcon(type) }></img>
                    <div>
                        <h4 className={ style.detailName }>Tipo</h4>
                        <h4 className={ style.detailValue }>{ getItalianType(type) }</h4>
                    </div>
                </div>
                <div className={ [style.detail, !subject && style.disabled].join(" ") } onClick={ () => {
                    if (!subject)
                        return;
                    setSelectingOption("date");
                } }>
                    <img src={ icons.calendar_orange_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>{ type === "interrogation" ? "Inizio" : "Data" }</h4>
                        <h4 className={ style.detailValue }>{ startDate?.getDate() } { getItalianMonth(startDate?.getMonth())?.substring(0, 3) }</h4>
                    </div>
                </div>
                { type === "interrogation" && <div className={ [style.detail, !subject && style.disabled].join(" ") } onClick={ () => {
                    if (!subject)
                        return;
                    setSelectingOption("date");
                } }>
                    <img src={ icons.calendar_orange_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>{ type === "interrogation" ? "Fine" : "Data" }</h4>
                        <h4 className={ style.detailValue }>{ endDate?.getDate() ?? "Scegli" } { getItalianMonth(endDate?.getMonth())?.substring(0, 3) }</h4>
                    </div>
                </div> }
                { type !== "interrogation" && <div className={ [style.detail, !subject && style.disabled].join(" ") } onClick={ e => {
                    e.stopPropagation();
                    if (!subject)
                        return;
                    setShowTimePicker(oldShowTimePicker => !oldShowTimePicker);
                    setShowDurationChoice(false);
                } }>
                    <img src={ icons.clock_orange_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>Orario</h4>
                        <h4 className={ style.detailValue }>{ prettifyDate(startDate.getUTCHours()) }:{ prettifyDate(startDate.getUTCMinutes()) }</h4>
                    </div>
                    <div className={ style.flex }>
                        {/* <div className={ style.durationSelect } style={{ height: showTimePicker && "25vh", right: "50%", borderTopRightRadius: "0", borderBottomRightRadius: "0" }} onClick={ e => e.stopPropagation() }>
                            { [...Array(24).keys()].map(hour => <div key={ `hour-${hour}` } style={{ borderTopRightRadius: "0", borderBottomRightRadius: "0" }} className={ [style.durationOption, startDate.getUTCHours() === hour && style.selected].join(" ") } onClick={ () => {
                                let newStartDate = new Date(startDate);
                                newStartDate.setUTCHours(hour);
                                
                                if (newStartDate.getDate() === startDate.getDate() + 1)
                                    newStartDate = addDays(newStartDate, - 1);
                                else if (newStartDate.getDate() === startDate.getDate() - 1)
                                    newStartDate = addDays(newStartDate, + 1);
                                    
                                setStartDate(newStartDate);
                            } }><h3>{ prettifyDate(hour) }</h3></div>) }
                        </div>
                        <div className={ style.durationSelect } style={{ height: showTimePicker && "25vh", right: "0", borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} onClick={ e => e.stopPropagation() }>
                            { [...Array(60).keys()].map(minute => <div key={ `minute-${minute} `} style={{ borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} className={ [style.durationOption, startDate.getUTCMinutes() === minute && style.selected].join(" ") } onClick={ () => {
                                let newStartDate = new Date(startDate);
                                newStartDate.setUTCMinutes(minute, 0, 0);

                                if (newStartDate.getDate() === startDate.getDate() + 1)
                                    newStartDate = addDays(newStartDate, - 1);
                                else if (newStartDate.getDate() === startDate.getDate() - 1)
                                    newStartDate = addDays(newStartDate, + 1);

                                setStartDate(newStartDate);
                            } }><h3>{ prettifyDate(minute) }</h3></div>) }
                        </div> */}
                        <div data-affectnavonscroll="false" className={ style.durationSelect } style={{ width: "100%", height: showTimePicker && `${100 * getSubjectLessons().length}%` }} onClick={ e => e.stopPropagation() }>
                            { getSubjectLessons()?.map(lesson => <div key={ `hour-${lesson[0] ?? lesson.startTime}` } className={ [style.durationOption, startDate.getUTCHours() === parseInt((lesson[0] ?? lesson.startTime).split(":")[0]) && style.selected].join(" ") } onClick={ () => {
                                let newStartDate = new Date(startDate);
                                newStartDate.setUTCHours(parseInt((lesson[0] ?? lesson.startTime).split(":")[0]));
                                newStartDate.setUTCMinutes(parseInt((lesson[0] ?? lesson.startTime).split(":")[1]));
                                
                                if (newStartDate.getDate() === startDate.getDate() + 1)
                                    newStartDate = addDays(newStartDate, - 1);
                                else if (newStartDate.getDate() === startDate.getDate() - 1)
                                    newStartDate = addDays(newStartDate, + 1);
                                    
                                setStartDate(newStartDate);
                                setDuration(1);
                            } }><h3>{ lesson[0] ?? lesson.startTime }</h3></div>) }
                        </div> 
                    </div>
                </div> }
                <Popup 
                    show={ replaceLessonPopup }
                    icon={ icons.info_icon } 
                    text="Sostituisci la lezione prevista per il giorno e l'ora dell'evento con questo evento - la materia di quell'ora diventerà la materia di questo evento" 
                    buttons={ <TextButton text="CHIUDI" style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }} onClick={ () => setReplaceLessonPopup(false) } /> } 
                />
                { type !== "interrogation" && <div className={ [style.detail, !subject && style.disabled].join(" ") } style={{ background: replaceLesson && "rgb(28, 126, 255)", position: "relative" }} onClick={ () => {
                    if (!subject)
                        return;

                    setReplaceLesson(oldReplaceLesson => !oldReplaceLesson) ;
                } }>
                    <img src={ icons.info_icon } className={ style.infoIcon } onClick={ e => {
                        e.stopPropagation();
                        setReplaceLessonPopup(true);
                    } }></img>
                    <img src={ icons.loop_orange_icon }></img>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <h4 className={ style.detailValue } style={{ marginTop: "auto", marginBottom: "auto", display: "block" }}>Scambia</h4>
                    </div>
                </div> }
                { type !== "interrogation" && <div className={ [style.detail, !subject && style.disabled].join(" ") } onClick={ e => {
                    e.stopPropagation();
                    if (!subject)
                        return;

                    setShowDurationChoice(oldShowDurationChoice => !oldShowDurationChoice);
                    setShowTimePicker(false);
                } }>
                    <img src={ icons.clock_orange_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>Durata</h4>
                        <h4 className={ style.detailValue }>{ duration } h</h4>
                    </div>
                    <div data-affectnavonscroll="false" className={ style.durationSelect } style={{ height: showDurationChoice && `${100 * getSubjectLessonsAfterSelected()?.length}%` }} onClick={ e => e.stopPropagation() }>
                        { getSubjectLessonsAfterSelected() && Object.keys(getSubjectLessonsAfterSelected()).map(index => <div key={ `duration-${parseInt(index) + 1}` } className={ [style.durationOption, duration === parseInt(index) + 1 && style.selected].join(" ") } onClick={ () => setDuration(parseInt(index) + 1) }><h3>{ parseInt(index) + 1 }</h3></div>) }
                        {/* { getSubjectLessons() && timetable[startDate.getDay()] && Object.keys(timetable[startDate.getDay()]).map((_, index) => <div key={ `duration-${parseInt(index) + 1}` } className={ [style.durationOption, duration === parseInt(index) + 1 && style.selected].join(" ") } onClick={ () => setDuration(parseInt(index) + 1) }><h3>{ parseInt(index) + 1 }</h3></div>) } */}
                        {/* <div className={ [style.durationOption, duration === 1 && style.selected].join(" ") } onClick={ () => setDuration(1) }><h3>1</h3></div>
                        <div className={ [style.durationOption, duration === 2 && style.selected].join(" ") } onClick={ () => setDuration(2) }><h3>2</h3></div>
                        <div className={ [style.durationOption, duration === 3 && style.selected].join(" ") } onClick={ () => setDuration(3) }><h3>3</h3></div>
                        <div className={ [style.durationOption, duration === 4 && style.selected].join(" ") } onClick={ () => setDuration(4) }><h3>4</h3></div>
                        <div className={ [style.durationOption, duration === 5 && style.selected].join(" ") } onClick={ () => setDuration(5) }><h3>5</h3></div>
                        <div className={ [style.durationOption, duration === 6 && style.selected].join(" ") } onClick={ () => setDuration(6) }><h3>6</h3></div> */}
                    </div>
                </div> }
                <div className={ style.detail } onClick={ e => {
                    e.stopPropagation();
                    setGrade(oldGrade => ({ ...oldGrade, show: !oldGrade.show }));
                } }>
                    <img src={ grade.inGradeAverage ? icons.leaderboard_icon : icons.leaderboard_empty_icon } className={ style.infoIcon } onClick={ e => {
                        e.stopPropagation();
                        setError({ show: true, error: grade.inGradeAverage ? "Voto escluso dalla media" : "Voto incluso nella media" })
                        setGrade(oldGrade => ({ ...oldGrade, inGradeAverage: !oldGrade.inGradeAverage }));
                    } }></img>
                    <img src={ icons.trash_icon } className={ style.infoIcon } style={{ top: "65%" }} onClick={ e => {
                        e.stopPropagation();
                        setGrade(oldGrade => ({ inGradeAverage: oldGrade.inGradeAverage }));
                    } }></img>
                    <img src={ icons.grade_orange_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>Voto</h4>
                        <h4 className={ style.detailValue } style={{ transition: "color .5s ease", color: grade.grade && (grade.inGradeAverage ? parseFloat(getNumericGrade(grade.grade)) >= 6 ? "rgb(0, 128, 0)" : parseFloat(getNumericGrade(grade.grade)) >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)" : "rgb(0, 99, 248)") }}>{ grade.grade ?? "Scegli" }</h4>
                    </div>
                    <div data-affectnavonscroll="false" className={ style.durationSelect } style={{ width: "100%", height: grade.show && `200%` }} onClick={ e => e.stopPropagation() }>
                        { literalGrades.map(gradeChoice => <div key={ `grades-${gradeChoice}` } className={ [style.durationOption, grade.grade === gradeChoice && style.selected].join(" ") } onClick={ () => setGrade(oldGrade => ({ ...oldGrade, grade: gradeChoice })) }><h3>{ gradeChoice }</h3></div>) }
                    </div>
                </div>
                <Popup
                    show={ showAttachments }
                    icon={ icons.attachment_icon } 
                    text="Allegati"
                    onClick={ () => setShowAttachments(false) }
                    buttons={ <div className={ style.attachments }>
                        { attachments.filter(attachment => !attachment.deleted).map(attachment => <div key={ `attachment-${attachment.name}` } className={ style.attachment }>
                            <img src={ icons.trash_icon } className={ style.attachmentIcon } onClick={ async e => {
                                e.stopPropagation();
                                if (attachment.bucket) setAttachments(oldAttachments => [ ...oldAttachments.filter(oldAttachment => oldAttachment.name !== attachment.name), { ...attachment, deleted: true } ]);
                                else setAttachments(oldAttachments => oldAttachments.filter(oldAttachment => oldAttachment.name !== attachment.name));

                                // await deleteObject(ref(storage, `${user.school}/${user.class}/${props.type}s/${props.id}/${attachment.name}`));
                            } }></img>
                            <h4 className={ style.attachmentName }>{ attachment.name }</h4>
                        </div>) }
                        <input type="file" id="attachments-add" name="attachments-add" style={{ display: "none" }} multiple onClick={ e => e.stopPropagation() } onChange={ e => {
                            try {
                                const totalSize = Object.values(e.target.files).map(file => file.size).reduce((total, fileSize) => total + fileSize);

                                if (totalSize > 1000 * 1000 * 10) {
                                    setError({ show: true, error: "La dimensione totale degli allegati non può superare i 5MB!" });
                                    return;
                                }
                            } catch (err) {
                                console.warn(err);
                            }

                            setAttachments(oldAttachments => ([ 
                                ...oldAttachments,
                                ...Object.values(e.target.files)
                                    .filter(file => !attachments.map(attachment => attachment.name ?? attachment._location?.path?.split("/")[-1])
                                    .includes(file.name))
                            ]));
                        } } />
                        <label htmlFor="attachments-add" onClick={ e => e.stopPropagation() } >
                            <IconButton icon={ icons.add_icon } style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "2rem" }} iconStyle={{ width: "1rem" }} text="Aggiungi file" />
                        </label>
                    </div> } />
                <Popup 
                    show={ premiumNeededPopup }
                    icon={ icons.premium_icon }
                    text="Passa a premium per poter usare questa funzione!"
                    onClick={ () => setPremiumNeededPopup(false) }
                    buttons={ <>
                        <IconButton icon={ icons.premium_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" text="PREMIUM" style={{ width: "80%", marginLeft: "auto", marginRight: "auto" }} onClick={ () => setPage({ page: "menu", menuPage: "premium", from: "add" }) } />
                        <TextButton text="CHIUDI" style={{ width: "80%", marginTop: "1rem", marginLeft: "auto", marginRight: "auto" }} onClick={ () => setPremiumNeededPopup(false) } />
                    </> } 
                />
                <div className={ [style.detail, !user.premium && style.disabled].join(" ") } onClick={ e => {
                    e.stopPropagation();

                    if (!user.premium) {
                        setPremiumNeededPopup(true);
                        return;
                    }

                    setShowAttachments(oldShowAttachments => !oldShowAttachments);
                } }>
                    <img src={ icons.attachment_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>Allegati</h4>
                        <h4 className={ style.detailValue }>{ attachments.filter(attachment => !attachment.deleted).length } file</h4>
                    </div>
                </div>
            </div>
            <h5 className={ style.subHeader }>Partecipanti</h5>
            <div className={ style.users }>                
                { eventUsers.slice(0, 5).map(eventUser => <img key={ eventUser } referrerPolicy="no-referrer" src={ users?.[eventUser]?.profilePicture || `https://eu.ui-avatars.com/api/?name=${users?.[eventUser]?.username}&background=d86c07&rounded=true&format=svg&color=fff` } className={ style.user } onClick={ () => setSelectingOption("users") }></img>) }
                { eventUsers.length === 0 && users && Object.values(users).slice(0, 5).map(eventUser => <img key={ eventUser.id } referrerPolicy="no-referrer" src={ eventUser?.profilePicture || `https://eu.ui-avatars.com/api/?name=${eventUser?.username}&background=d86c07&rounded=true&format=svg&color=fff` } className={ style.user } onClick={ () => setSelectingOption("users") }></img>) }
                { users && (eventUsers.length > 0 ? eventUsers : Object.keys(users)).length > 5 && <span className={ style.moreUsers } onClick={ () => setSelectingOption("users") }>+{ (eventUsers.length > 0 ? eventUsers : Object.keys(users)).length - 5  }</span> }
                <img src={ icons.add_orange_icon } className={ style.addUser } onClick={ () => setSelectingOption("users") }></img>
            </div>            
            <Popup 
                show={ showUploadingAttachments }
                icon={ icons.attachment_icon } 
                text="Caricamento allegati"
                buttons={ <div className={ style.uploadingAttachments }>
                    { Object.values(uploadingAttachments).map(attachment => <div key={ `attachment-${attachment.name}` } className={ style.attachment }>
                        { attachment.uploaded ? <img src={ icons.check_icon } className={ style.attachmentIcon }></img> : <div className={ [style.spinner, style.attachmentIcon].join(" ") } style={{ width: "1rem", height: "1rem" }}></div> }
                        <h4 className={ style.attachmentName }>{ attachment.name }</h4>
                        <h5 className={ style.attachmentProgress }>{ attachment.progress }%</h5>
                    </div>) }
                </div> } />
            <TextButton loading={ saving } text="SALVA" style={{ width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "-2rem", marginBottom: "1rem", padding: ".25rem 0" }} fontSize="1.1rem" onClick={ save } />
            { oldType && <TextButton loading={ saving } text="ELIMINA" style={{ background: "linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)", width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "0", marginBottom: "2rem", padding: ".25rem 0" }} fontSize="1.1rem" onClick={ deleteEvent } /> }
        </main>
    </>;
};

export default Add;
